import { Component, OnInit, Output, EventEmitter, ViewChild, Input, Injector, ComponentFactoryResolver, Inject, LOCALE_ID } from '@angular/core';
import { ComboListComponent } from '@farris/ui-combo-list';
import { ProcessListHelpService } from '../../services/process-list-help.service';
import { MessagerService } from '@farris/ui-messager';
import { NotifyService } from '@farris/ui-notify';
import { GSPMetadataRTService, SelectMetadataRTComponent, Metadata4RefDto } from '@gsp-lcm/metadatart-selector';
import { BsModalService } from '@farris/ui-modal';
import { GSPViewModel } from '@gsp-bef/gsp-vo-metadata';
import { IRtProcQueryParam } from '../../entity/IProcQueryParam';
import { TextValue } from '@edp-bif/common-api';
import { BifMetadataType } from '../../entity/BifMetadataType';
import { CommonModelTypeHelper } from '../../utils/common-model-type-helper';
import { VOTemplateType } from '../../entity/VOTemplateType';
import { AifLocalePipe } from '../../../aif-ui-common/pipe/aif-ui-common-locale.pipe';

@Component({
  selector: 'app-proc-help-query-solution',
  templateUrl: './proc-help-query-solution.component.html',
  styleUrls: ['./proc-help-query-solution.component.css'],
})
export class ProcHelpQuerySolutionComponent implements OnInit {
  readonly groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  @Input("queryParam")
  queryParam: IRtProcQueryParam;
  @Output("queryParamChange")
  queryParamChange = new EventEmitter<IRtProcQueryParam>();

  @Output("onSearch")
  onSearchEmitter = new EventEmitter();

  // //流程类型配置
  // @ViewChild("comboProcessType")
  // comboProcessType: ComboListComponent;
  // comboProcessTypeIdField = "value";
  // comboProcessTypeValueField = "value";
  // comboProcessTypeTextField = "text";
  // comboProcessTypeData = [
  //   { value: "", text: this.localePipe.transform("all") },
  //   { value: BifMetadataType.BifCreationProcess, text: this.localePipe.transform("creation") },
  //   { value: BifMetadataType.BifWritebackProcess, text: this.localePipe.transform("writeback") },
  // ];

  // //启用状态配置
  // @ViewChild("comboEnabledState")
  // comboEnabledState: ComboListComponent;
  // comboEnabledStateIdField = "value";
  // comboEnabledStateValueField = "value";
  // comboEnabledStateTextField = "text";
  // comboEnabledStateData = [
  //   { value: "", text: this.localePipe.transform("all") },
  //   { value: "true", text: this.localePipe.transform("enabled") },
  //   { value: "false", text: this.localePipe.transform("disabled") },
  // ];

  //系统预置配置
  @ViewChild("comboSysInit")
  comboSysInit: ComboListComponent;
  comboSysInitIdField = "value";
  comboSysInitValueField = "value";
  comboSysInitTextField = "text";
  comboSysInitData = [
    { value: "", text: this.localePipe.transform("all") },
    { value: "true", text: this.localePipe.transform("yes") },
    { value: "false", text: this.localePipe.transform("no") },
  ];

  constructor(
    private procHelpService: ProcessListHelpService,
    private messager: MessagerService,
    private notify: NotifyService,
    private metadataService: GSPMetadataRTService,
    private modalService: BsModalService,
    private injector: Injector,
    private resolver: ComponentFactoryResolver,
    private localePipe: AifLocalePipe,
  ) {
  }

  ngOnInit() {
  }

  processNameChange(name: string) {
    this.queryParam.filterArgs.name = new TextValue();
    this.queryParam.filterArgs.name.hasValue = true;
    this.queryParam.filterArgs.name.value = name;
    this.queryParam.filterArgsExt.name = name;
  }

  processTypeChange({ selections }) {
    const item = selections[0];
    this.queryParam.filterArgs.billProcessType = new TextValue();
    if (item != null) {
      if (item.value != "") {
        this.queryParam.filterArgs.billProcessType.hasValue = true;
      }
      this.queryParam.filterArgs.billProcessType.value = item.value;
    }
  }

  enabledStateChange({ selections }) {
    const item = selections[0];
    this.queryParam.filterArgs.isEnabled = new TextValue();
    if (item != null) {
      if (item.value != "") {
        this.queryParam.filterArgs.isEnabled.hasValue = true;
      }
      this.queryParam.filterArgs.isEnabled.value = String(item.value);
    }
  }

  sysInitChange({ selections }) {
    const item = selections[0];
    this.queryParam.filterArgs.sysInit = new TextValue();
    if (item != null) {
      if (item.value != "") {
        this.queryParam.filterArgs.sysInit.hasValue = true;
      }
      this.queryParam.filterArgs.sysInit.value = String(item.value);
    }
  }

  /**
   * 打开上游单据VO选择器
   */
  selectUpBill() {
    const compFactory = this.resolver.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.typeList = "GSPViewModel";

    compRef.instance.selectedMetadata.subscribe(
      (metadata4RefDto: Metadata4RefDto) => {
        this.clearUpBill();
        let upVODto = metadata4RefDto.metadata;
        let upVO: GSPViewModel = JSON.parse(upVODto.content);

        switch (CommonModelTypeHelper.judgeVoTemplateType(upVO)) {
          //非代理VO
          case VOTemplateType.FromBE:
            {
              this.queryParam.filterArgs.upBillVoId = new TextValue();
              this.queryParam.filterArgs.upBillVoId.hasValue = true;
              this.queryParam.filterArgs.upBillVoId.value = upVO.ID;
              this.queryParam.filterArgsExt.upBillVoName = upVO.MainObject.Name;
            }
            break;
          default:
            this.notify.error(this.localePipe.transform("pleaseSelectNonVirtualVO"));
            break;
        };
      },
      (err) => {
        console.error(err);
        //todo 确定异常结构, 目前采用兼容取值方式
        this.messager.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
        this.clearUpBill();
      }
    );

    const modalConfig = {
      title: this.localePipe.transform("billSelector"),
      width: 930,
      height: 573,
      showButtons: false
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }

  /**
   * 打开下游单据VO选择器
   */
  selectDownBill() {
    const compFactory = this.resolver.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.typeList = "GSPViewModel";

    compRef.instance.selectedMetadata.subscribe(
      (metadata4RefDto: Metadata4RefDto) => {
        this.clearDownBill();
        let downVODto = metadata4RefDto.metadata;
        let downVO: GSPViewModel = JSON.parse(downVODto.content);

        switch (CommonModelTypeHelper.judgeVoTemplateType(downVO)) {
          //非代理VO
          case VOTemplateType.FromBE:
            {
              this.queryParam.filterArgs.downBillVoId = new TextValue();
              this.queryParam.filterArgs.downBillVoId.hasValue = true;
              this.queryParam.filterArgs.downBillVoId.value = downVO.ID;
              this.queryParam.filterArgsExt.downBillVoName = downVO.MainObject.Name;
            }
            break;
          default:
            this.notify.error(this.localePipe.transform("pleaseSelectNonVirtualVO"));
            break;
        };
      },
      (err) => {
        console.error(err);
        //todo 确定异常结构, 目前采用兼容取值方式
        this.messager.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
        this.clearUpBill();
      }
    );

    const modalConfig = {
      title: this.localePipe.transform("billSelector"),
      width: 930,
      height: 573,
      showButtons: false
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }

  /**
   * 清除流程名称
   */
  clearProcessName() {
    delete this.queryParam.filterArgs.name;
    this.queryParam.filterArgsExt.name = null;
  }

  /**
   * 清除选中的流程类型
   */
  clearProcessType() {
    delete this.queryParam.filterArgs.billProcessType;
  }

  /**
   * 清除选中的上游单据信息
   */
  clearUpBill() {
    delete this.queryParam.filterArgs.upBillVoId;
    this.queryParam.filterArgsExt.upBillVoName = null;
  }

  /**
   * 清除选中的下游单据信息
   */
  clearDownBill() {
    delete this.queryParam.filterArgs.downBillVoId;
    this.queryParam.filterArgsExt.downBillVoName = null;
  }

  /**
   * 清除选中的启用状态
   */
  clearIsEnabled() {
    delete this.queryParam.filterArgs.isEnabled;
  }

  /**
   * 清除选中的发布状态
   */
  clearIsPublished() {
    // delete this.queryParam.filterArgs.isPublished;
  }

  /**
   * 清除选中的发布状态
   */
  clearSysInit() {
    delete this.queryParam.filterArgs.sysInit;
  }

  /**
   * 点击筛选按钮
   */
  clickBtnFilter() {
    this.queryParam.filterArgs.pageIndex = 0;
    this.onSearchEmitter.emit(this.queryParam);
  }

  /**
   * 点击清空按钮
   */
  clickBtnClear() {
    //重置下拉框
    // this.comboProcessType.onClear();
    // this.comboProcessTypeData = this.comboProcessTypeData.map(item => ({ ...item }));

    // this.comboEnabledState.onClear();
    // this.comboEnabledStateData = this.comboEnabledStateData.map(item => ({ ...item }));

    // this.comboSysInit.onClear();
    // this.comboSysInitData = this.comboSysInitData.map(item => ({ ...item }));

    // this.comboPublishedState.onClear();
    // this.comboPublishedStateData = this.comboPublishedStateData.map(item => ({ ...item }));

    //重置查询参数
    // const queryParam = {
    //   filterArgs: new ProcessFilterConditionArgs(),
    //   filterArgsExt: {}
    // };
    // queryParam.filterArgs.LoadFromJsonObject(this.queryParam.filterArgs.ConvertToJsonObject());

    const queryParam = this.queryParam;
    queryParam.filterArgsExt = {};

    queryParam.filterArgs.upBillVoId = null;
    queryParam.filterArgs.downBillVoId = null;
    queryParam.filterArgs.sysInit = null;
    queryParam.filterArgs.name = null;

    // queryParam.filterArgs.pageSize = this.queryParam.filterArgs.pageSize;
    // queryParam.filterArgs.pageIndex = this.queryParam.filterArgs.pageIndex;
    // queryParam.filterArgs.orderByCode = this.queryParam.filterArgs.orderByCode;
    // queryParam.filterArgs.orderByName = this.queryParam.filterArgs.orderByName;
    // queryParam.filterArgs.OrderByLastModifiedTime = this.queryParam.filterArgs.OrderByLastModifiedTime;

    this.queryParam = queryParam;
  }
}
